import React from 'react'

const HeadingComponent = ({ heading, treepath, rules = 0 }) => {
  return <>
    <div
      style={{
        display: "flex",
        justifyContent: treepath ? "space-between" : "flex-start",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <h3 style={{ margin: 0, lineHeight: 1.25 }}>{heading}</h3>
      {treepath ? (
        <div style={{ color: "rgb(136, 136, 136)", fontSize: "14px", fontWeight: "normal", flexShrink: 0 }}>
          {treepath}
        </div>
      ) : null}
    </div>
    {Array.from({ length: rules }, (_, index) => <hr key={heading+index} />)}
  </>
}

export default HeadingComponent